import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import HelpCenterHeader from '../../components/help-center/HelpCenterHeader';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import HelpCenterDetail from '../../components/help-center/HelpCenterDetail';

const HelpCenter = () => {
  return (
    <Layout >
      <div 
      style={{ background: "radial-gradient(75% 25% at 50% 0%, rgb(216 223 235), rgb(255, 255, 255))" }}
      >
      <PageMeta />
      <Navbar  />
      <HelpCenterHeader />
      <HelpCenterDetail />
      <FooterOne
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat bottom left",
        }}
      />
      </div>
    </Layout>
  );
};

export default HelpCenter;
